import React from "react";
import { NavLink } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { Nav, NavItem } from "mdbreact";
import All from "./All";
import MainApp from "../../layouts/MainApp";
import Tiers from "./Tiers";

const tabs = [
  { name: "KYC", href: "all" },
  { name: "KYC Tiers", href: "tiers" },
];

export default function KYC() {
  const { pathname } = useLocation();

  return (
    <MainApp>
      <div className="main-content-padding">
        <div className="mb-5">
          <div className="sm:block">
            <Nav tabs className="mb-3 flex-nowrap overflow-auto">
              {tabs.map((singleTab) => (
                <NavItem key={singleTab.name}>
                  <NavLink
                    to={`/kyc/${singleTab.href}/1`}
                    className={
                      pathname.includes(singleTab.href)
                        ? "active font-weight-bold text-primary border-bottom border-primary px-4 py-2"
                        : "text-muted px-4 py-2"
                    }
                    aria-current={
                      pathname.includes(singleTab.href) ? "page" : undefined
                    }
                  >
                    {singleTab.name}
                  </NavLink>
                </NavItem>
              ))}
            </Nav>
          </div>
        </div>

        <div>
          {pathname.includes("all") && <All />}
          {pathname.includes("tiers") && <Tiers />}
        </div>
      </div>
    </MainApp>
  );
}
